import { InjectionToken } from '@angular/core';

import { NavEnvironment } from './environment.interface';

/**
 * @const ENVIRONMENT
 * Injection token for the environment interface to be provided by the applications.
 */
export const NAV_ENVIRONMENT: InjectionToken<NavEnvironment> = new InjectionToken('NAV_ENVIRONMENT');